export const EVENT_ADD_TO_CART = 'addToCart';
export const EVENT_ADD_TO_CART_WITH_TRADE_IN = 'addToCartWithTradeIn';
export const EVENT_SWITCH_TAB = 'switchTab';
export const EVENT_LOAD_DETAILS = 'loadDetails';
export const EVENT_PREORDER_REQUEST = 'requestPreorder';
export const EVENT_SUCCESS_PICKUP_BUY = 'successPickupBuy';
export const EVENT_CLICK_BUNDLE_BUY = 'clickBundleBuy';
export const EVENT_CARD_CLICK_PROMO_BANNER = 'cardClickPromoBanner';
export const EVENT_CARD_VIEW_PROMO_BANNER = 'cardViewPromoBanner';

// feedback events
export const EVENT_FEEDBACK_SUCCESS = 'feedbackSuccess';

// notify popup events
export const EVENT_NOTIFY_POPUP_OPEN = 'notifyPopupOpen';
export const EVENT_NOTIFY_POPUP_FILLED = 'notifyPopupFilled';
export const EVENT_NOTIFY_POPUP_SUBSCRIBED = 'notifyPopupSubscribed';
export const EVENT_NOTIFY_POPUP_CLOSED = 'notifyPopupClosed';

// ===
export const EVENT_ADD_ACCESSORY = 'addAccessory';
export const EVENT_VIEW_ACCESSORY = 'viewAccessory';
export const EVENT_OPEN_ACCESSORY_POPUP = 'openAccessoryPopup';
export const EVENT_ADD_RECENTLY_VIEWED = 'addRecentlyViewed';
export const EVENT_VIEW_RECENTLY = 'viewRecently';
export const EVENT_VIEW_RECENTLY_VIEWED = 'viewRecentlyViewed';
export const EVENT_VIEW_RECENTLY_SWITCHED = 'viewRecentlySwitched';

// pickup buy events
export const EVENT_OPEN_BALLOON_PICKUPBUY = 'openBalloonPickupBuy';
export const EVENT_CLOSE_BALLOON_PICKUPBUY = 'closeBalloonPickupBuy';
export const EVENT_CLICK_BUTTON_PICKUPBUY = 'clickButtonPickupBuy';
export const EVENT_OPEN_FORM_PICKUPBUY = 'openFormViewPickupBuy';
export const EVENT_OPEN_POPUP_PICKUPBUY = 'openPopupPickupBuy';
export const EVENT_CLOSE_POPUP_PICKUPBUY = 'closePopupPickupBuy';
export const EVENT_BLUR_SEARCH_PICKUPBUY = 'blurSearchMap';
export const EVENT_CONTACT_FILLED_PICKUPBUY = 'popupContactFilled';
// ===

// catalog events
export const EVENT_CATALOG_UPDATE = 'CatalogUpdate';
export const EVENT_CATALOG_LOAD = 'CatalogLoad';
export const EVENT_CATALOG_CHANGE_VIEW = 'CatalogChangeView';
export const EVENT_CATALOG_VIEW_PROMO_BANNER = 'CatalogViewPromoBanner';
export const EVENT_CATALOG_CLICK_PROMO_BANNER = 'CatalogClickPromoBanner';
export const EVENT_CATALOG_TOGGLE_FILTER = 'CatalogToggleFilter';
export const EVENT_CATALOG_SHOW_MORE_FILTER = 'CatalogShowMoreFilter';
export const EVENT_CATALOG_PRICE_FILTER = 'CatalogPriceFilter';
export const EVENT_CATALOG_POPUP_DETAILS_OPEN = 'CatalogPopupDetailsOpen';
export const EVENT_CATALOG_PRODUCT_DETAILS_OPEN = 'CatalogProductDetailsOpen';
export const EVENT_CATALOG_PRODUCT_DETAILS_OPEN_WITH_TRADE_IN =
  'CatalogProductDetailsOpenWithTradeIn';
export const EVENT_CATALOG_PRODUCT_DETAILS_OPEN_WITH_BNPL = 'CatalogProductDetailsOpenWithBnpl';
export const EVENT_CATALOG_PRODUCTS_SEEN = 'CatalogProductsSeen';
export const EVENT_CATALOG_PRODUCTS_SEEN_WITH_TRADE_IN = 'CatalogProductsSeenWithTradeIn';
export const EVENT_CATALOG_PRODUCTS_SEEN_WITH_BNPL = 'CatalogProductsSeenWithBnpl';
export const EVENT_CATALOG_PRODUCTS_SEEN_WITH_BADGES = 'CatalogProductsSeenWithBadges';
export const EVENT_CATALOG_PRODUCT_CLICK_WITH_BADGES = 'CatalogProductClickWithBadges';

export const EVENT_CATALOG_PRODUCTS_SEEN_WITH_INSTALLMENT = 'CatalogProductsSeenWithInstallment';
export const EVENT_CATALOG_ADD_PRODUCT_WITH_INSTALLMENT_TO_BASKET =
  'CatalogAddProductWithInstallmentToBasket';
export const EVENT_CATALOG_PRODUCT_DETAILS_OPEN_WITH_INSTALLMENT =
  'CatalogProductDetailsOpenWithInstallment'
// ===
export const EVENT_COMMON_SWITCH_TO_CARD = 'CommonSwitchToCard';
export const EVENT_COMMON_ADD_TO_CART = 'CommonAddToCart';

/**
 * re-export widgets
 */
export * from './widgets/threeFours/eventTypes';

// trade-in page events
export const EVENT_SELECT_TRADE_IN = 'SelectTradeIn';
// scroll to top button
export const SCROLL_TOP_BTN_CLICK = 'ScrollToTopButtonClick';
// sharedPage events
export const EVENT_PROMO_CLICK_BUTTON_BUY = 'PromoClickButtonBuy';
export const EVENT_PROMO_CLICK_DETAILS = 'PromoClickDetails';
export const EVENT_PROMO_VIEW_BANNERS = 'PromoViewBanners';
export const EVENT_PROMO_CLICK_BANNER = 'PromoClickBanner';
export const EVENT_PROMO_VIEW_SLIDER = 'PromoViewSlider';
export const EVENT_PROMO_MOVE_SLIDER = 'PromoMoveSlider';
export const EVENT_PRODUCT_DAY_VIEW = 'ProductDayView';
export const EVENT_PRODUCT_DAY_CLICK = 'ProductDayClick';
export const EVENT_PRODUCT_ADD_TO_CART = 'ProductAddToCart';

export const EVENT_BANNER_BLOCKS_BANNER_VIEW = 'BannerBlocksBannerView';
export const EVENT_BANNER_BLOCKS_BANNER_CLICK = 'BannerBlocksBannerClick';

/* sharedPage widgets events */
export const EVENT_VOTE_FORM_WIDGET_VOTE = 'VoteFormWidgetClick';
export const EVENT_VOTE_FORM_WIDGET_SUBSCRIBE = 'VoteFormWidgetSubscribe';

export const EVENT_NEW_MAIN_PAGE_VIEW = 'NewMainPageView';
/* dashamail events */
export const EVENT_MAIL_SUBSCRIPTION = 'emailSubscription';

/* subscibe events */
export const EVENT_SUBSCRIBE_SUCCESS = 'SubscribeSuccess';
export const EVENT_SUBSCRIBE_ERROR = 'SubscribeError';

/** special details events */
export const EVENT_CLICK_BUY_SALE = 'clickBuyButtonOnSale';
export const EVENT_SUCCESS_SALE_BUY = 'successSaleBuy';

/** favorites events */
export const ADD_TO_FAVORITE_FROM_CATALOG = 'addToFavoriteFromCatalog';
export const REMOVE_FROM_FAVORITE_FROM_CATALOG = 'removeFromFavoriteFromCatalog';
export const ADD_TO_FAVORITE_FROM_MODAL = 'addToFavoriteFromModal';
export const REMOVE_FROM_FAVORITE_FROM_MODAL = 'removeFromFavoriteFromModal';
export const ADD_TO_FAVORITE_FROM_DETAILS_PAGE = 'addToFavoriteFromDetailsPage';
export const REMOVE_FROM_FAVORITE_FROM_DETAILS_PAGE = 'removeFromFavoriteDetailsPage';

export const REMOVE_FROM_FAVORITE = 'removeFromFavorite';
export const ADD_TO_FAVORITE = 'addToFavorite';
export const REMOVE_FROM_FAVORITE_ALL = 'removeFromFavoriteAll';

/** comparison events */
export const ADD_TO_COMPARISON_FROM_CATALOG = 'addToComparisonFromCatalog';
export const REMOVE_FROM_COMPARISON_FROM_CATALOG = 'removeFromComparisonFromCatalog';
export const ADD_TO_COMPARISON_FROM_MODAL = 'addToComparisonFromModal';
export const REMOVE_FROM_COMPARISON_FROM_MODAL = 'removeFromComparisonFromModal';
export const ADD_TO_COMPARISON_FROM_DETAILS_PAGE = 'addToComparisonFromDetailsPage';
export const REMOVE_FROM_COMPARISON_FROM_DETAILS_PAGE = 'removeFromComparisonDetailsPage';

export const REMOVE_FROM_COMPARISON = 'removeFromComparison';
export const ADD_TO_COMPARISON = 'addToComparison';
export const REMOVE_FROM_COMPARISON_ALL = 'removeFromComparisonAll';

export const SELECT_TRADE_IN_DEVICE_TYPE = 'selectTradeInDeviceType';
export const SELECT_TRADE_IN_DEVICE_BRAND = 'selectTradeInDeviceBrand';
export const SELECT_TRADE_IN_DEVICE_MODEL = 'selectTradeInDeviceModel';
export const SELECT_TRADE_IN_DEVICE_CAPACITY = 'selectTradeInDeviceCapacity';
export const SELECT_TRADE_IN_MAX_PRICE = 'selectTradeInMaxPrice';
export const SELECT_TRADE_IN_TO_PURCHASE = 'selectTradeInToPurchase';
export const SHOW_DEVICE_DETAILS_WITH_TRADE_IN = 'showDeviceDetailWithTradeIn';
export const SHOW_BEELINE_OFFICE_SERVICE = 'showBeelineOfficeService';
export const SHOW_RANDOM_SERVICE = 'showRandomService';
export const SHOW_FAQ = 'showFaq';
/** main page events */
export const SHOW_MAIN_SLIDER_BANNER = 'showMainSliderBanner';
export const CLICK_MAIN_SLIDER_BANNER = 'clickMainSliderBanner';

export const SHOW_MAIN_STATIC_BANNER = 'showMainStaticBanner';
export const CLICK_MAIN_STATIC_BANNER = 'clickMainStaticBanner';

export const EVENT_MAIN_RECOMMENDS_SEEN_WITH_BADGES = 'MainRecommendsSeenWithBadges';
export const EVENT_MAIN_RECOMMENDS_CLICK_WITH_BADGES = 'MainRecommendsClickWithBadges';

export const SHOW_MAIN_SUBSCRIBER_BANNER = 'showMainSubscriberBanner';
export const CLICK_MAIN_SUBSCRIBER_BANNER = 'clickMainSubscriberBanner';
export const EVENT_PRODUCT_DETAILS_CLICK_SHOW_REVIEWS = 'ProductDetailsClickShowReviews';
export const EVENT_PRODUCT_DETAILS_CLICK_LINK = 'ProductDetailsClickLink';
export const EVENT_PRODUCT_DETAILS_CLICK_MENU = 'ProductDetailsClickMenu';
export const EVENT_PRODUCT_DETAILS_VIEW_OUT_OF_STOCK_FORM = 'ProductDetailsViewOutOfStockForm';
export const EVENT_PRODUCT_DETAILS_SUCCESS_OUT_OF_STOCK_FORM =
  'ProductDetailsSuccessOutOfStockForm';
export const EVENT_PRODUCT_DETAILS_CLICK_WRITE_REVIEW = 'ProductDetailsClickWriteReview';
export const EVENT_PRODUCT_DETAILS_CLICK_POST_REVIEW = 'ProductDetailsClickPostReview';
export const EVENT_PRODUCT_DETAILS_CLICK_DELIVERY_TYPE = 'ProductDetailsClickDeliveryType';
export const EVENT_PRODUCT_DETAILS_SEARCH_SHOP_INPUT_FOCUS = 'ProductDetailsSearchShopInputFocus';
export const EVENT_PRODUCT_DETAILS_SEARCH_SHOP_INPUT_RESULT = 'ProductDetailsSearchShopInputResult';
export const EVENT_PRODUCT_DETAILS_CLICK_DELIVERY_PICKUP = 'ProductDetailsClickDeliveryPickup';
export const EVENT_PRODUCT_DETAILS_PICKUP_BUY_OPEN = 'ProductDetailsPickupBuyOpen';
export const EVENT_PRODUCT_DETAILS_PICKUP_BUY_SUCCESS = 'ProductDetailsPickupBuySuccess';
export const EVENT_PRODUCT_DETAILS_PICKUP_BUY_ERROR = 'ProductDetailsPickupBuyError';
export const EVENT_PRODUCT_DETAILS_CLICK_INSTALLMENT = 'ProductDetailsClickInstallment';

export const EVENT_SUBSCRIPTION_VIEW = 'SubscriptionView';
export const EVENT_SIMPLE_RECOMMENDS_VIEW = 'SimpleRecommendsView';
export const EVENT_SIMPLE_RECOMMENDS_DEVICE_CLICK = 'SimpleRecommendsDeviceClick';
export const EVENT_SIMPLE_RECOMMENDS_TAB_CLICK = 'SimpleRecommendsTabClick';
export const EVENT_SIMPLE_RECOMMENDS_BANNER_CLICK = 'SimpleRecommendsBannerClick';
export const EVENT_SIMPLE_RECOMMENDS_GO_TO_BASKET_CLICK = 'SimpleRecommendsGoToBasketClick';

/** Navigation component events */
export const EVENT_NAVIGATION_ITEM_CLICK = 'NavigationItemClick';
export const EVENT_NAVIGATION_ITEM_VIEW = 'NavigationItemView';
export const EVENT_NESTED_COLLECTION_ITEM_VIEW = 'nestedCollectionItemView';
export const EVENT_NESTED_COLLECTION_ITEM_CLICK = 'nestedCollectionItemClick';

/** filter component events */
export const EVENT_FILTER_SELECT = 'filterSelect';
export const EVENT_FILTER_CLEAR = 'filterClear';

/** bnpl events */
export const EVENT_PRODUCT_DETAILS_HOVER_BNPL_TOOLTIP = 'ProductDetailsHoverBnplTooltip';
export const EVENT_BNPL_TOOLTIP_LEARN_MORE = 'BnplTooltipLearnMore';
export const EVENT_ADD_TO_CART_WITH_BNPL = 'addToCartWithBnpl';
